export const mobileData = [{

        "id": "1",
        "product": "Mobile",
        "image": "/assets/NewMobile/1.png",
        "company": "Apple",
        "model": "iPhone 13 Pro",
        "price": "1099.00",
        "category": "Electronics",
        "description": "The latest iPhone model with advanced camera capabilities and powerful performance."
    },
    {
        "id": "2",
        "product": "Mobile",
        "image": "/assets/NewMobile/2.jpg",
        "company": "Samsung",
        "model": "Galaxy Z Fold 3",
        "price": "1799.00",
        "category": "Electronics",
        "description": "A foldable smartphone with a large display and multitasking features."
    },
    {
        "id": "3",
        "product": "Mobile",
        "image": "/assets/NewMobile/3.jpg",
        "company": "Google",
        "model": "Pixel 6",
        "price": "799.99",
        "category": "Electronics",
        "description": "A Google Pixel phone with exceptional camera quality and the latest Android features."
    },
    {
        "id": "4",
        "product": "Mobile",
        "image": "/assets/NewMobile/4.jpg",
        "company": "OnePlus",
        "model": "9 Pro",
        "price": "899.00",
        "category": "Electronics",
        "description": "A flagship OnePlus phone known for its smooth performance and fast charging."
    },
    {
        "id": "5",
        "product": "Mobile",
        "image": "/assets/NewMobile/5.jpg",
        "company": "Xiaomi",
        "model": "Mi 11 Ultra",
        "price": "999.50",
        "category": "Electronics",
        "description": "A high-spec Xiaomi phone with a versatile camera system and powerful hardware."
    },
    {
        "id": "6",
        "product": "Mobile",
        "image": "/assets/NewMobile/6.jpg",
        "company": "Sony",
        "model": "Xperia 1 III",
        "price": "1199.00",
        "category": "Electronics",
        "description": "A Sony Xperia phone with a 4K display and pro-level camera features."
    },
    {
        "id": "7",
        "product": "Mobile",
        "image": "/assets/NewMobile/7.jpg",
        "company": "LG",
        "model": "G9 ThinQ",
        "price": "749.00",
        "category": "Electronics",
        "description": "An LG smartphone with AI-enhanced features and a sleek design."
    },
    {
        "id": "8",
        "product": "Mobile",
        "image": "/assets/NewMobile/8.jpg",
        "company": "Motorola",
        "model": "Edge 20",
        "price": "599.99",
        "category": "Electronics",
        "description": "A Motorola Edge phone with 5G capabilities and a high-refresh-rate display."
    },
    {
        "id": "9",
        "product": "Mobile",
        "image": "/assets/NewMobile/9.jpg",
        "company": "Huawei",
        "model": "P50 Pro",
        "price": "1299.00",
        "category": "Electronics",
        "description": "A Huawei flagship phone with advanced camera technology and sleek aesthetics."
    },
    {
        "id": "10",
        "product": "Mobile",
        "image": "/assets/NewMobile/10.jpg",
        "company": "Oppo",
        "model": "Find X5 Pro",
        "price": "899.50",
        "category": "Electronics",
        "description": "An Oppo Find X phone with innovative design and impressive camera features."
    },
    {
        "id": "11",
        "product": "Mobile",
        "image": "/assets/NewMobile/11.jpg",
        "company": "Nokia",
        "model": "8.4 5G",
        "price": "549.00",
        "category": "Electronics",
        "description": "A Nokia smartphone with 5G connectivity and a focus on reliability."
    },
    {
        "id": "12",
        "product": "Mobile",
        "image": "/assets/NewMobile/12.jpg",
        "company": "Realme",
        "model": "GT Master Edition",
        "price": "379.99",
        "category": "Electronics",
        "description": "A Realme phone designed in collaboration with a renowned designer, featuring a unique aesthetic."
    }
]